import VueRouter from 'vue-router';

import Businesses from '@/pages/Businesses.vue';
import Login from '@/pages/Login.vue';
import Forget from '@/pages/Forget/index.vue';
import DashboardLayout from '@/pages/Layout/DashboardLayout';
import Profile from '@/pages/PersonalProfile/index.vue';
import BatchOrder from '@/pages/BatchOrder/index.vue';
import BatchOrderView from '@/pages/BatchOrder/show.vue';
import ReportDetail from '@/pages/Reports/Detail.vue';
import SettingsLayout from '@/pages/Layout/SettingsLayout';
import CustomerProfileLayout from '@/pages/Layout/CustomerProfileLayout.vue';
// import WebhookHistory from '@/pages/Settings/Webhook/History';
import AuthGuard from '../guards/auth.guard';
import { settingsRoutes, customersProfileRoutes } from '../config/index';
import dashboard from './dashboard';

const settings = {
  path: 'settings',
  label: 'Settings',
  icon: 'settings',
  meta: {
    resources: ['settings'],
    requireAuth: false,
    label: 'Settings',
  },
  component: SettingsLayout,
  children: settingsRoutes,
};
const customerDetails = {
  path: '/customers',
  label: 'Customerd Details',
  icon: 'customers',
  meta: {
    resources: ['customers'],
    requireAuth: false,
    label: 'Customers Details',
  },
  component: CustomerProfileLayout,
  children: customersProfileRoutes,
};

export const routes = [
  {
    path: '/',
    component: DashboardLayout,
    beforeEnter: AuthGuard.isAuthenticatedRoute,
    children: [...dashboard, customerDetails, settings],
  },
  {
    path: '/batch-order',
    component: DashboardLayout,
    children: [
      {
        path: '',
        component: BatchOrder,
        name: 'Batch Order',
        beforeEnter: AuthGuard.isAuthenticatedRoute,
        meta: {
          label: 'Batch Order',
        },
      },
      {
        path: ':id',
        component: BatchOrderView,
        name: 'Batch Orders > Run Results',
        beforeEnter: AuthGuard.isAuthenticatedRoute,
        meta: {
          label: 'Batch Orders > Run Results',
        },
      },
    ],
  },
  {
    path: '/batch-order',
    component: DashboardLayout,
    children: [
      {
        path: '',
        component: BatchOrder,
        name: 'Batch Order',
        beforeEnter: AuthGuard.isAuthenticatedRoute,
        meta: {
          label: 'Batch Order',
        },
      },
      {
        path: ':id',
        component: BatchOrderView,
        name: 'View Batch Order',
        beforeEnter: AuthGuard.isAuthenticatedRoute,
        meta: {
          label: 'View Batch Order',
        },
      },
    ],
  },
  {
    path: '/reports',
    component: DashboardLayout,
    children: [
      {
        path: ':id',
        component: ReportDetail,
        name: 'Report Details',
        beforeEnter: AuthGuard.isAuthenticatedRoute,
        meta: {
          label: 'Report Details',
        },
      },
    ],
  },
  {
    path: '/profile',
    component: DashboardLayout,
    children: [
      {
        path: '',
        component: Profile,
        name: 'Profile',
        beforeEnter: AuthGuard.isAuthenticatedRoute,
        meta: {
          // resources: ["business"],
          // requireAuth: true,
          label: 'Profile',
        },
      },
      {
        path: 'businesses',
        component: Businesses,
        name: 'Switch Business',
        beforeEnter: AuthGuard.isAuthenticatedRoute,
        meta: {
          // resources: ["business"],
          // requireAuth: true,
          label: 'Switch Business',
        },
      },
    ],
  },
  {
    path: '/businesses',
    name: 'Select Business',
    component: Businesses,
  },
  {
    path: '/signin',
    beforeEnter: AuthGuard.isUnAuthenticatedRoute,
    component: Login,
  },
  {
    path: '/forget',
    component: Forget,
  },
  // { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound }
];

const router = new VueRouter({
  routes,
  // linkExactActiveClass: "nav-item active",
  linkActiveClass: 'nav-item active',
  mode: 'history',
});

router.beforeEach(AuthGuard.isAuthorizedRoute);

export default router;
